export enum ApplicationType {
  Launchpad,
  Design,
  Setup,
  Admin,
}
